import ModalImport from 'Features/Modal/ModalImport';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {ProModalProps} from 'Components/ProModal';
import {downloadTagTemplate, importTag} from '../../service';

const Index = ({...props}: ProModalProps) => {
    const [onUpload] = useRequestFn(async file => {
        await importTag(file);
        props.onOk?.();
    });

    return (
        <ModalImport
            {...props}
            title="二级分类导入模板"
            onUpload={onUpload}
            ajaxDownloadFun={downloadTagTemplate}
            templateName="数据导入模板"
            restSteps={<div>2.&nbsp;在导入模板补充好用户数据后上传文件</div>}
        />
    );
};

export default Index;
